export enum BlockSize {
  Full,
  Half,
}

export default BlockSize;
